import './bootstrap';


// // flot 
// require("jquery.flot");
// require("jquery.flot/jquery.flot.time.js");

//chart js 
import Chart from 'chart.js/auto'; // or 'chart.js' if you're using the bundle



//swal 2
import sweetalert2 from 'sweetalert2/dist/sweetalert2';
window.Swal = sweetalert2;
